import { render, staticRenderFns } from "./ProvisioningControlBanner.vue?vue&type=template&id=6bc5c2ed&scoped=true"
import script from "./ProvisioningControlBanner.vue?vue&type=script&lang=ts"
export * from "./ProvisioningControlBanner.vue?vue&type=script&lang=ts"
import style0 from "./ProvisioningControlBanner.vue?vue&type=style&index=0&id=6bc5c2ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc5c2ed",
  null
  
)

export default component.exports